import { render } from "./QuantidadeOSChart.vue?vue&type=template&id=04b0aba4"
import script from "./QuantidadeOSChart.vue?vue&type=script&lang=js"
export * from "./QuantidadeOSChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__